import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary-dark text-white pt-16 pb-8 border-t border-primary-light" data-id="element-54">
      <div className="container mx-auto px-4" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-56">
          {/* Brand Column */}
          <div data-id="element-57">
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-58">
              Premier World Discovery
            </h3>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-59">
              Dedicated to providing exceptional group travel experiences
              worldwide. We specialize in custom tours for affinity groups,
              clubs, and organizations.
            </p>
            <div className="flex space-x-4" data-id="element-60">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-61">
                <Facebook size={20} data-id="element-62" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-63">
                <Instagram size={20} data-id="element-64" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-65">
                <Twitter size={20} data-id="element-66" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-67">
                <Linkedin size={20} data-id="element-68" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div data-id="element-69">
            <h4 className="font-bold text-lg mb-6 text-gold" data-id="element-70">Contact Us</h4>
            <ul className="space-y-4 text-sm text-gray-300" data-id="element-71">
              <li className="flex items-start" data-id="element-72">
                <MapPin size={18} className="mr-3 mt-0.5 text-teal flex-shrink-0" data-id="element-73" />
                <span data-id="element-74">
                  2615 - 190th Street, Suite 200
                  <br data-id="element-75" />
                  Redondo Beach, CA 90278
                </span>
              </li>
              <li className="flex items-center" data-id="element-76">
                <Phone size={18} className="mr-3 text-teal flex-shrink-0" data-id="element-77" />
                <span data-id="element-78">(877) 953-8687</span>
              </li>
              <li className="flex items-center" data-id="element-79">
                <Mail size={18} className="mr-3 text-teal flex-shrink-0" data-id="element-80" />
                <span data-id="element-81">info@premierworlddiscovery.com</span>
              </li>
              <li className="text-xs text-gray-500 mt-2" data-id="element-82">
                Mon-Fri: 7:30am - 5:00pm PST
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-83">
            <h4 className="font-bold text-lg mb-6 text-gold" data-id="element-84">Quick Links</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-85">
              <li data-id="element-86">
                <a href="#" className="hover:text-white transition-colors" data-id="element-87">
                  Group Travel
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-white transition-colors" data-id="element-89">
                  Travel Styles
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="hover:text-white transition-colors" data-id="element-91">
                  Online Brochure
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="hover:text-white transition-colors" data-id="element-93">
                  Premier Difference
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-white transition-colors" data-id="element-95">
                  Our 10 Commitments
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="hover:text-white transition-colors" data-id="element-97">
                  Book with Web Code
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-98">
            <h4 className="font-bold text-lg mb-6 text-gold" data-id="element-99">Support</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-100">
              <li data-id="element-101">
                <a href="#" className="hover:text-white transition-colors" data-id="element-102">
                  Contact Us
                </a>
              </li>
              <li data-id="element-103">
                <a href="#" className="hover:text-white transition-colors" data-id="element-104">
                  FAQ
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="hover:text-white transition-colors" data-id="element-106">
                  Travel Protection
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="hover:text-white transition-colors" data-id="element-108">
                  Careers
                </a>
              </li>
              <li data-id="element-109">
                <a href="#" className="hover:text-white transition-colors" data-id="element-110">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-white transition-colors" data-id="element-112">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-light pt-8 text-center text-xs text-gray-500" data-id="element-113">
          <p data-id="element-114">
            &copy; {new Date().getFullYear()} Premier World Discovery. All
            rights reserved. CST #2048841-40
          </p>
        </div>
      </div>
    </footer>;
}